import React from 'react';
import { Box } from '@mui/material';

const Background = () => {
  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: '-15%',
          right: '-10%',
          width: '50%',
          height: '50%',
          borderRadius: '50%',
          background: '#080a16',
          filter: 'blur(25px)',
          opacity: 0.6,
          zIndex: 1
        }}
      />
      <Box
        sx={{
          position: 'fixed',
          bottom: '10%',
          left: '-10%',
          width: '40%',
          height: '40%',
          borderRadius: '50%',
          background: '#021710',
          filter: 'blur(35px)',
          opacity: 0.5,
          zIndex: 1
        }}
      />
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: '#000000',
          zIndex: 0
        }}
      />
    </>
  );
};

export default Background;